import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PlantListCompanyByUserGuidState } from './plant-list-company-by-userguid.models';

export const selectPlantListCompanyByUserGuidState =
  createFeatureSelector<PlantListCompanyByUserGuidState>('plantListCompanyByUserGuid');

export const selectPlantListByUserGuid = (userGuid: string) =>
  createSelector(selectPlantListCompanyByUserGuidState, (state) => state.plants[userGuid] || null);

export const selectPlantListCompanyByUserGuidLoading = createSelector(
  selectPlantListCompanyByUserGuidState,
  (state) => state.loading,
);

export const selectPlantListCompanyByUserGuidError = createSelector(
  selectPlantListCompanyByUserGuidState,
  (state) => state.error,
);
